/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CanaleComunicazione } from './canale-comunicazione';


export interface VoucherConsegnaComunicazioneDTO { 
    /**
     * Canali abilitati e con un testo per l\'evento VOUCHER_EMESSO; vuota se alla consegna non partirà alcuna comunicazione
     */
    canali?: Array<CanaleComunicazione>;
}

